if (!customElements.get('product-engraving-selector')) {
  class ProductEngravingSelector extends HTMLElement {
    constructor() {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.handleTextInput = this.handleTextInput.bind(this);
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.charLimit = parseInt(this.dataset.charLimit) || 10;
      this.engravingOptionValue = this.dataset.engravingOptionValue;

      this.optionsContainer = this.querySelector('[data-engraving-options]');
      this.textInput = this.querySelector('[data-engraving-text]');
      this.charCount = this.querySelector('[data-char-count]');
      this.fontInputs = this.querySelectorAll('[data-engraving-font]');

      this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
      this.textInput.addEventListener('input', this.handleTextInput);
      this.textInput.addEventListener('compositionend', this.handleTextInput);

      this.checkInitialVariant();
    }

    disconnectedCallback() {
      if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
      if (this.textInput) {
        this.textInput.removeEventListener('input', this.handleTextInput);
        this.textInput.removeEventListener('compositionend', this.handleTextInput);
      }
    }

    checkInitialVariant() {
      const checked = document.querySelectorAll(
        `[data-section="${this.sectionId}"] input[type="radio"]:checked`
      );
      const hasEngraving = Array.from(checked).some(
        (radio) => radio.value.toLowerCase() === this.engravingOptionValue.toLowerCase()
      );
      if (checked.length > 0 && hasEngraving) {
        this.showEngravingOptions();
      } else {
        this.hideEngravingOptions();
      }
    }

    handleVariantChange(event) {
      const variant = event.data?.variant;
      if (!variant) return;
      const options = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
      const hasEngraving = options.some(
        (opt) => opt && opt.toLowerCase() === this.engravingOptionValue.toLowerCase()
      );
      if (hasEngraving) {
        this.showEngravingOptions();
      } else {
        this.hideEngravingOptions();
      }
    }

    showEngravingOptions() {
      this.engravingActive = true;
      this.optionsContainer.removeAttribute('hidden');
      this.enableFormFields();
      this.updateAddToCartState();
    }

    hideEngravingOptions() {
      this.engravingActive = false;
      this.optionsContainer.setAttribute('hidden', '');
      this.clearFields();
      this.disableFormFields();
      this.updateAddToCartState();
    }

    enableFormFields() {
      const formId = `product-form-${this.sectionId}`;
      this.textInput.setAttribute('form', formId);
      this.fontInputs.forEach((input) => input.setAttribute('form', formId));
    }

    disableFormFields() {
      this.textInput.removeAttribute('form');
      this.fontInputs.forEach((input) => input.removeAttribute('form'));
    }

    clearFields() {
      this.textInput.value = '';
      if (this.charCount) this.charCount.textContent = '0';
      this.fontInputs.forEach((input, i) => { input.checked = i === 0; });
    }

    handleTextInput(event) {
      if (!event.isComposing) {
        const sanitized = event.target.value.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ0-9 ,.\-\/&]/g, '');
        if (sanitized !== event.target.value) event.target.value = sanitized;
      }
      if (this.charCount) this.charCount.textContent = event.target.value.length;
      this.updateAddToCartState();
    }

    updateAddToCartState() {
      const isDisabled = this.engravingActive && (!this.textInput.value || this.textInput.value.trim() === '');
      const buttons = document.querySelectorAll(
        `#product-form-${this.sectionId} button[name="add"], product-form[data-section-id="${this.sectionId}"] button[name="add"], .product-sticky-bar button[name="add"]`
      );
      buttons.forEach((btn) => {
        btn.toggleAttribute('disabled', isDisabled);
        btn.classList.toggle('disabled', isDisabled);
        btn.setAttribute('aria-disabled', String(isDisabled));
      });
    }
  }

  customElements.define('product-engraving-selector', ProductEngravingSelector);
}
